const extensions = /\.(mp4|mov|m4v|mkv|webm|avi)$/i;
const mimeExtensions: Record<string, string> = {
  "video/mp4": "mp4",
  "video/quicktime": "mov",
  "video/x-m4v": "m4v",
  "video/webm": "webm",
  "video/x-matroska": "mkv",
  "video/avi": "avi",
  "video/msvideo": "avi",
  "video/x-msvideo": "avi",
};
export function videoUploadName(file: File): string {
  if (!file.size)
    throw new Error(
      "This video is empty or not downloaded to your phone. Save it to your device, then select it again.",
    );
  if (file.size > 50 * 1024 * 1024)
    throw new Error(
      `This video is ${(file.size / 1024 / 1024).toFixed(1)} MB. The limit is 50 MB per clip. Choose a smaller video.`,
    );
  if (extensions.test(file.name)) return file.name;
  const extension = mimeExtensions[file.type.toLowerCase().split(";")[0]];
  if (extension) return `${file.name || "video"}.${extension}`;
  throw new Error(
    "This video format is not supported. Choose MP4, MOV, M4V, MKV, WebM or AVI.",
  );
}
